module.exports = __webpack_public_path__ + "img/staff-stuart-field.42d9e806.jpg";